import React, { useState } from 'react';
import { apiGet } from '../lib/api';
import Icon from '../components/icons';
import { EmptyState } from './ListView';

export default function Audit(){
  const [runId, setRunId] = useState('');
  const [logs, setLogs] = useState([]);
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);
  const [searched, setSearched] = useState(false);

  const load = () => {
    if (!runId) return;
    setErr('');
    setLogs([]);
    setLoading(true);
    setSearched(true);
    apiGet(`/runs/${runId}/audit`)
      .then(setLogs)
      .catch(e => setErr(String(e)))
      .finally(() => setLoading(false));
  };

  return (
    <main className="page">
      <div className="page__header">
        <span className="page__icon"><Icon name="audit" /></span>
        <div className="page__header-text">
          <h2>Audit Logs</h2>
          <p>Full event trail for a given orchestration run — every routing decision, sync, and status change.</p>
        </div>
      </div>
      <section className="panel">
        <div className="search-bar search-bar--inline">
          <Icon name="search" className="search-bar__icon" />
          <input
            className="field-input search-bar__input"
            placeholder="Enter Run ID…"
            value={runId}
            onChange={e => setRunId(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') load(); }}
          />
          <button className="btn-primary btn-small" onClick={load} disabled={!runId || loading}>
            {loading ? 'Loading…' : 'Load'}
          </button>
        </div>
        {err && <div className="status status--error">{err}</div>}
        {searched && !loading && !err && logs.length === 0 && (
          <EmptyState label={`No audit entries found for run #${runId}.`} />
        )}
        {logs.length > 0 && (
          <ul className="audit-list">
            {logs.map((l, i) => (
              <li key={i} className="audit-list__item">
                <span className="audit-list__time">{l.event_at ? new Date(l.event_at).toLocaleString() : '—'}</span>
                <span className="audit-list__type">{l.event_type}</span>
                <code className="audit-list__data">{JSON.stringify(l.data)}</code>
              </li>
            ))}
          </ul>
        )}
      </section>
    </main>
  );
}
